export default {
  leaflet:
    'pk.eyJ1IjoiY2FycG8tYWkiLCJhIjoiY2tvcjAyeTZzMGhiZzJ3cGRmajRjY3NvYSJ9.oFg4_QSrJKefSv7o7HrrdA',
  api: 'https://core.carpo.tech/api/v1/',
  api2: 'https://core.carpo.tech/api/v2/',
  oldtile: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  tile: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
}
